import { api } from './api';

/**
 * One capture button (v1 ticket 44). The server's `health.oneButton` decides; read once and remembered here so
 * the views that draw the two ways in (home, the empty land, the onboarding) can ask without waiting. With the
 * flag off (or unread) everything is as before: Record and Type.
 */
let on = false;
let read: Promise<boolean> | null = null;
let settled = false;

export function oneButtonOn(): boolean {
  return on;
}

/** Whether the flag has been read (so a screen that must not guess can wait for it). */
export function flagRead(): boolean {
  return settled;
}

/** Reads `health.oneButton` once (a failed read leaves it off and reads again next time). */
export function loadOneButton(): Promise<boolean> {
  read ??= api.health().then(
    (h) => { settled = true; return (on = !!h.oneButton); },
    () => { read = null; return on; },
  );
  return read;
}

/** For tests and for the views that already hold the health reply. */
export function setOneButton(v: boolean): void {
  on = v;
  read = Promise.resolve(v);
  settled = true;
}

/** A refused microphone opens the quill with one line the panel shows there (ticket 44); taken once. */
let quillLine = '';

export function setQuillLine(s: string): void {
  quillLine = s;
}

export function takeQuillLine(): string {
  const s = quillLine;
  quillLine = '';
  return s;
}
